const cleanWord = (value) => String(value || '').trim().replace(/\s+/g, ' ');

const wordKey = (value) => cleanWord(value).normalize('NFKC').toLocaleLowerCase('en-US');

export const groupLearnedWordsByDate = (studyByDay = []) => {
  const seen = new Set();

  return [...(Array.isArray(studyByDay) ? studyByDay : [])]
    .filter((record) => record && typeof record.date === 'string')
    .sort((left, right) => left.date.localeCompare(right.date))
    .map((record) => {
      const words = [];
      (Array.isArray(record.learned_words) ? record.learned_words : []).forEach((rawWord) => {
        const word = cleanWord(rawWord);
        const key = wordKey(word);
        if (!word || seen.has(key)) return;
        seen.add(key);
        words.push(word);
      });
      return { date: record.date, words };
    })
    .filter((record) => record.words.length > 0);
};

const dateParts = (date) => {
  const match = String(date || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
};

export const formatLearnedDate = (date, locale = 'en', includeYear = false) => {
  const parts = dateParts(date);
  if (!parts) return String(date || '');
  if (locale === 'zh-CN') {
    return includeYear
      ? `${parts.year}年${parts.month}月${parts.day}日`
      : `${parts.month}月${parts.day}日`;
  }
  return new Intl.DateTimeFormat('en', {
    month: 'long',
    day: 'numeric',
    ...(includeYear ? { year: 'numeric' } : {}),
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(parts.year, parts.month - 1, parts.day)));
};

export const formatLearnedWordList = (groups = [], locale = 'en') => {
  const years = new Set(groups.map((group) => dateParts(group.date)?.year).filter(Boolean));
  const includeYear = years.size > 1;
  return groups
    .map((group) => [formatLearnedDate(group.date, locale, includeYear), ...group.words].join('\n'))
    .join('\n\n');
};

export const countGroupedLearnedWords = (groups = []) => (
  groups.reduce((total, group) => total + group.words.length, 0)
);
